export interface GetDistrictListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetDistrictListPagingAndFilterResponseData
}

export interface GetDistrictListPagingAndFilterResponseData {
    items: GetDistrictListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetDistrictListPagingAndFilterResponseItem {
    districtId: string
    code: string
    name: string
    countryId: any
    countryName: any
    countyId: string
    countyName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetDistrictListPagingAndFilterResponseData: GetDistrictListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}